import { type ComponentProps } from 'react';
import { cn } from '@shared/lib/cn';

export type LabelProps = ComponentProps<'label'>;

/**
 * Wrapper around the native `label` element. Consumers must pass `htmlFor`
 * pointing to the associated input — TypeScript doesn't enforce it but a11y
 * does. ESLint can't see through component composition; suppressed at JSX site.
 */
export function Label({ className, ...props }: LabelProps): React.JSX.Element {
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label
      className={cn(
        'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
        className,
      )}
      {...props}
    />
  );
}
